import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_6 = { class: "d-flex align-items-center gap-3" }
const _hoisted_7 = { class: "search-box position-relative" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_9 = {
  key: 1,
  class: "queues-list"
}
const _hoisted_10 = { class: "queue-card-header d-flex align-items-center justify-content-between" }
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "d-flex align-items-center gap-2 mb-1" }
const _hoisted_13 = { class: "mb-0 fw-bold" }
const _hoisted_14 = { class: "mb-0 small" }
const _hoisted_15 = { class: "ms-2" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "dossiers-badge" }
const _hoisted_18 = { class: "queue-card-body" }
const _hoisted_19 = {
  key: 0,
  class: "text-center py-3 text-muted"
}
const _hoisted_20 = {
  key: 1,
  class: "row g-2"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_23 = {
  key: 0,
  class: "badge bg-danger rounded-pill"
}
const _hoisted_24 = {
  key: 1,
  class: "badge bg-success rounded-pill"
}
const _hoisted_25 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Files de Validation", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchRef) = $event)),
                  class: "form-control shadow-none rounded border",
                  placeholder: "Rechercher par référence BESC...",
                  style: {"min-width":"280px"}
                }, null, 512), [
                  [_vModelText, _ctx.searchRef]
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "flaticon-search-interface-symbol position-absolute top-50 end-0 translate-middle-y me-3 text-muted" }, null, -1))
              ]),
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "btn btn-primary transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1" }, null, -1),
                  _createElementVNode("span", null, "Retour", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          (_ctx.queues.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "flaticon-info-circle me-2" }, null, -1),
                _createTextVNode(" Aucune file de validation trouvée. ", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queuesWithDossiers, (queue) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: queue.id,
                    class: _normalizeClass(["queue-card mb-4", _ctx.getRiskCardClass(queue.maxRiskLevel)])
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "flaticon-users" }, null, -1)),
                          _createElementVNode("h5", _hoisted_13, _toDisplayString(queue.name), 1)
                        ]),
                        _createElementVNode("p", _hoisted_14, [
                          _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Code:", -1)),
                          _createTextVNode(" " + _toDisplayString(queue.code) + " ", 1),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(queue.pays?.name_fr) + " - " + _toDisplayString(queue.port?.nomPort), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getBescsCount(queue.id)) + " dossiers", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.getBescsByQueue(queue.id).length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "flaticon-folder-open" }, null, -1),
                            _createElementVNode("p", { class: "mb-0 small" }, "Aucun dossier dans cette file", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBescsByQueue(queue.id), (besc) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: besc.id,
                                class: "col-12 col-md-4"
                              }, [
                                _createElementVNode("div", {
                                  class: "besc-item d-flex flex-column gap-1",
                                  onClick: ($event: any) => (_ctx.viewBescDetail(besc.id))
                                }, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("strong", null, _toDisplayString(besc.refbesc), 1),
                                    (besc.flagsCount > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "flaticon-flag" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(besc.flagsCount) + " flags ", 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_24, "OK"))
                                  ]),
                                  _createElementVNode("small", _hoisted_25, [
                                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "flaticon-calendar me-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.format_Date(besc.createdAt)), 1)
                                  ])
                                ], 8, _hoisted_21)
                              ]))
                            }), 128))
                          ]))
                    ])
                  ], 2))
                }), 128))
              ]))
        ])
      ])
    ])
  ]))
}